import { render, staticRenderFns } from "./ManualRaiseDetails.vue?vue&type=template&id=bf733dac&scoped=true"
import script from "./ManualRaiseDetails.vue?vue&type=script&lang=ts"
export * from "./ManualRaiseDetails.vue?vue&type=script&lang=ts"
import style0 from "./ManualRaiseDetails.vue?vue&type=style&index=0&id=bf733dac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf733dac",
  null
  
)

export default component.exports